
import { Interview } from "@/types/interview";
import { InterviewMapperService } from "../base/interviewMapperService";
import { getArticles } from "@/lib/articlesApi";

/**
 * Service for fetching published interviews
 */
export class PublishedInterviewsService {
  /**
   * Fetch all published interviews
   */
  static async getPublishedInterviews(): Promise<Interview[]> {
    console.log('[PublishedInterviewsService] Using articles API');
    
    try {
      const data = await getArticles();
      
      if (!data || !Array.isArray(data)) {
        console.log('[PublishedInterviewsService] No data returned');
        return [];
      }
      
      const mapped = data.map(interview => InterviewMapperService.mapDatabaseInterviewToModel(interview as any));
      console.log('[PublishedInterviewsService] Successfully got', mapped.length, 'interviews');
      return mapped;
    } catch (error) {
      console.error('[PublishedInterviewsService] Error:', error);
      throw error;
    }
  }
}
